import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';

import { BoxDiv } from './box';
import Definition from './definition';


const Section = styled(BoxDiv)`
  width:95%;
  margin-top:10px;
  margin-bottom:10px;
  border: 1px solid #eaf5fb;
  padding: 34px 40px 41px 40px;
  page-break-inside: avoid;
  background-color:#f6f9fa; 
  border-radius: 40px;
`;
const jdyfcss = {
    color: '#333',
    fontWeight: 'bold',
    fontSize: '29px',
    width: '100%',
    lineHeight: '68px'

};

class ClassicPrescription extends React.Component {
    getmaxscore(arrayobj) {
        let maxi = 0;
        for (let i = 0; i < arrayobj.length; i++) {
            if (arrayobj[maxi].score <= arrayobj[i].score) {
                maxi = i;
            }
        }
        return arrayobj[maxi].name;
    }
    renderOneSection(symptomName) {
        const { solutions } = this.props.examination;
        if (!solutions) return null;
        console.log(symptomName)
        const explaining = solutions.prescription;
        const jdyf1 = symptomName.name;

        if (
            !explaining

        ) return null;

        const [definition, ...reason] = symptomName.content;
        return (
            <Section className='xiangxi' >
                <span style={jdyfcss} >{jdyf1}</span>
                <Definition
                    name='药物组成'
                    explain={[
                        definition,
                    ]} />
                <Definition
                    name='功效'
                    explain={reason.map((r, i) => `${r}`)} />
            </Section>
        );
    }
    render() {
        const { symptoms } = this.props.examination;
        const symptomsName = this.getmaxscore(symptoms);
        console.log(symptomsName);
        const { solutions } = this.props.examination;
        if (!solutions) return null;

        const explaining = solutions.prescription;
        const jdyf1 = explaining[symptomsName];
        if (
            !explaining ||
            !explaining[symptomsName]
        ) return null;
        return (
            <div>
                {jdyf1.map((e, i) => (
                    // eslint-disable-next-line react/no-array-index-key

                    this.renderOneSection(e)

                ))}
            </div>
        );
    }
}

ClassicPrescription.propTypes = {
    examination: PropTypes.object.isRequired,
};

export default ClassicPrescription;



// WEBPACK FOOTER //
// ./src/components/classic-prescription.jsx